export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-hammer-line',
      bgColor: 'bg-blue-100',
      title: 'Document Service of Process',
      description: 'Professional serving of summons, complaints, subpoenas, writs, and all legal documents with guaranteed proof of service.',
      link: 'Learn More →',
    },
    {
      icon: 'ri-government-line',
      bgColor: 'bg-green-100',
      title: 'Electronic Court Filing',
      description: 'Certified e-filing services for all California courts, plus traditional filing assistance for jurisdictions requiring in-person submission.',
      link: 'Learn More →',
    },
    {
      icon: 'ri-search-line',
      bgColor: 'bg-purple-100',
      title: 'Skip Tracing & Location',
      description: 'Advanced defendant location services using comprehensive databases and investigative techniques to ensure successful service.',
      link: 'Learn More →',
    },
    {
      icon: 'ri-file-list-3-line',
      bgColor: 'bg-orange-100',
      title: 'Legal Document Preparation',
      description: 'Expert preparation of small claims complaints, proof of service forms, and all court-required documentation with accuracy guaranteed.',
      link: 'Learn More →',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 border border-[#1a2b4a] rounded-full mb-4">
            <span className="text-sm font-medium text-[#1a2b4a]">Our Services</span>
          </div>
          <h2 className="text-5xl font-bold text-[#1a2b4a] mb-4">
            Comprehensive Legal Support Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From initial service to final filing, we handle every detail with precision and professionalism
          </p>
        </div>

        <div className="grid grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className={`w-14 h-14 flex items-center justify-center ${service.bgColor} rounded-full mb-6`}>
                <i className={`${service.icon} text-2xl text-[#1a2b4a]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-4">{service.title}</h3>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <a href="#" className="text-sm font-medium text-[#ff6b35] hover:text-[#e55a25] transition-colors cursor-pointer">
                {service.link}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
